import 'vue2-dropzone/dist/vue2Dropzone.min.css';

// import { TokenService } from '@/services/Storage.Service.js';
const { VUE_APP_CDN_URL } = process.env;

const baseURL = VUE_APP_CDN_URL;
// const xauth = VUE_APP_XAUTH;
// const xkey = VUE_APP_X_API_KEY;
// const bearerToken = TokenService.getToken();
const defaultDropzoneOptions = {
  headers: {
    // Authorization: xauth,
    // 'x-api-key': xkey,
    // Token: bearerToken
  }
};

import errorHandler from '@/mixins/errorHandler';
import vue2Dropzone from 'vue2-dropzone';

export default {
  mixins: [errorHandler],
  components: {
    vueDropzone: vue2Dropzone
  },
  data() {
    return {
      dropzoneSingleImageOptions: {
        acceptedFiles: 'image/*',
        url: `${baseURL}upload/single`,
        ...defaultDropzoneOptions,
        thumbnailWidth: 350,
        maxFiles: 1,
        maxFilesize: 5,
        addRemoveLinks: true
      },
      dropzoneMultipleFileOptions: {
        acceptedFiles: 'image/*',
        url: `${baseURL}upload/single`,
        ...defaultDropzoneOptions,
        thumbnailWidth: 350,
        maxFiles: 5,
        maxFilesize: 5,
        addRemoveLinks: true
      }
    };
  }
};
